module.exports = __webpack_public_path__ + "static/media/map_holder_img.cd416f27.svg";